import { FaClipboardCheck } from 'react-icons/fa';
import { useParams } from 'react-router-dom';
import SubHeading from '../../../../Components/SubHeading';
import EventsTableTabs from '../../../user/Home/sections/components/Events/EventsTableTabs';

function EventReportType() {
  const { type } = useParams();
  return (
    <div className="card">
      <div className="card-header">
        <SubHeading id="sidebar.report" Icon={FaClipboardCheck} />
      </div>
      <div className="card-body">
        <EventsTableTabs type={type} />
      </div>
    </div>
  );
}

export default EventReportType;
